import React from "react";
import Retool from ".";
import EmptyState from "components/EmptyState";
import { buildingStore } from "store/Building/BuildingStore";
import { useParams } from "react-router";

const MaterialValueDashboard = () => {
  const reportID = "98739f2a-ab10-11ef-9949-23211deaaaea";
  const { id: BuildingId } = useParams();

  const embeddedData = {
    building_id: BuildingId,
  };

  if (!buildingStore.buildingMappingStatus.hasReport)
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.calculationsStatus.inProgress}
        containerClassName="m-6"
      />
    );

  return (
    <Retool
      url={reportID}
      embeddedData={embeddedData}
      className="h-[calc(100vh-120px)]"
    />
  );
};

export default MaterialValueDashboard;
